// extracted by mini-css-extract-plugin
module.exports = {"section":"RapidPro_section__v2zXl"};